import { IServiceRequestsState } from '@telstra-connect/service-requests/state';
import { IRequestCreateRequest } from '@telstra-connect/service-requests/state/create-new-request';
import {
    IServiceRequestCategoryWithItemQuestionsRequest
} from '@telstra-connect/service-requests/state/request-category-with-item-questions';
import { State as CustomerProfileState } from '@telstra-connect/tokens';

export interface IServiceRequestsAppState {
    serviceRequests: IServiceRequestsState;
    tokens?: CustomerProfileState.ICustomerProfileState;
    validationErrors?: IServiceRequestsState;
};

export interface INewServiceRequestsAppState {
    serviceRequests?: IServiceRequestsState;
    createServiceRequest?: IRequestCreateRequest;
    wizardData?: IServiceRequestsState;
    questionsListRequest?: IServiceRequestCategoryWithItemQuestionsRequest;
    fileUploadRequest?: IServiceRequestsState;
    validationErrors?: IServiceRequestsState;
    tokens?: CustomerProfileState.ICustomerProfileState;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const mapStateToNotificationsCount = (state: IServiceRequestsAppState): number => {
    return 0;
};
